import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as Storage from "../lib/Storage.ts";

Html.registerWidget('widget/activity-sorting',{initDom})

function initDom(obj: HTMLElement){
  const select = obj as HTMLSelectElement;
  select.value = Storage.localGet('wallsortby') || 'sortingDate';

  select.addEventListener('change', function(this: HTMLSelectElement) {
    Storage.localSet('wallsortby', this.value);
    amplify.publish("activityFilterSelected", {sortBy: this.value});
  });
}
// Note: destroyDom inutile - le nœud supprimé nettoie automatiquement ses listeners
